// 菜单 侧边栏
export default [{
    path: '/index',
    title: '首页',
    icon: 'home'
  },

  {
    title: '概览',
    icon: 'folder-o',
    children: [{
      path: '/data-statistics',
      title: '数据统计-dev'
    }, ]
  },
  {
    title: '用户管理',
    icon: 'folder-o',
    children: [{
        path: '/blogger-list',
        title: '用户列表'
      },
      {
        path: '/blogger-search',
        title: '搜索推荐博主-dev'
      },
      {
        path: '/blogger-tag',
        title: '标签推荐博主-dev'
      },
    ]
  },
  {
    title: '内容管理',
    icon: 'folder-o',
    children: [{
        path: '/soft-article',
        title: '软文列表'
      },
      {
        path: '/content-tags',
        title: '标签管理-dev'
      },
      {
        path: '/prohibited-words',
        title: '违禁词语管理-dev'
      },
    ]
  },
  {
    title: '聊天管理',
    icon: 'folder-o',
    children: [{
      path: '/group-list',
      title: '群列表-dev'
    }, ]
  },
  {
    title: '贡献值管理',
    icon: 'folder-o',
    children: [{
      path: '/contribution-points',
      title: '贡献值明细-dev'
    }, ]
  },
  {
    title: '钱包管理',
    icon: 'folder-o',
    children: [{
        path: '/wallet-assets',
        title: '钱包资产'
      },

      {
        path: '/wallet-balance',
        title: '钱包余额-dev'
      },

    ]
  },
  {
    title: '财务管理',
    icon: 'folder-o',
    children: [
      {
        path: '/token-list',
        title: '币种管理'
      },
      {
        path: '/finance-address',
        title: '地址列表-dev'
      },

      {
        path: '/finance-recharge',
        title: '充值明细-dev'
      },
      {
        path: '/finance-withdrawal',
        title: '提现明细'
      },
      {
        path: '/finance-transfer',
        title: '划转明细-dev'
      },

    ]
  },
  {
    title: '消息管理',
    icon: 'folder-o',
    children: [{
        path: '/messages-system-notifications',
        title: '系统消息-dev'
      },

      {
        path: '/messages-notification-templates',
        title: '通知模板-dev'
      },
      {
        path: '/messages-notification-queue',
        title: '通知队列-dev'
      },

    ]
  },
  {
    title: '系统设置',
    icon: 'folder-o',
    children: [{
        path: '/system-settings',
        title: '角色管理-dev'
      },
      {
        path: '/admin-list',
        title: '管理员列表'
      },

    ]
  },



  // ------
  // {
  //   title: '测试页面',
  //   icon: 'folder-o',
  //   children: [{
  //       path: '/page1',
  //       title: '页面 1'
  //     },
  //     {
  //       path: '/page2',
  //       title: '页面 2'
  //     },
  //     {
  //       path: '/page3',
  //       title: '页面 3'
  //     }
  //   ]
  // },
]